import React, { useState, useEffect, useRef } from "react";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import {
  saveModifyConfiguration,
  getConfiguration,
} from "../../../services/configurations/configuration";
import handleError from "../../../utils/handleError";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const Configuration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useRef(null);
  const { token } = useSelector((state) => state.auth);

  const [baseValue, setBaseValue] = useState("");
  const [initialBaseValue, setInitialBaseValue] = useState("");
  const [recordId, setRecordId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const renderHeaderAndControls = () => (
    <div className="d-flex justify-content-between align-items-center px-3 py-3">
      <h6 className="fw-bold m-0 title">Configurations</h6>
    </div>
  );

  const handleSaveConfiguration = () => {
    if (!baseValue || baseValue === initialBaseValue || isSaving) return;

    setIsSaving(true);
    const formData = new FormData();
    formData.append("base_size", baseValue);
    if (recordId) {
      formData.append("record_id", recordId);
    }

    saveModifyConfiguration(token, formData)
      .then((response) => {
        if (response?.status === 200) {
          setInitialBaseValue(baseValue);
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Configuration saved successfully.",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Unexpected response from server.",
            life: 3000,
          });
        }
      })
      .catch((error) => {
        handleError(error, navigate, dispatch);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to save configuration.",
          life: 3000,
        });
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  useEffect(() => {
    getConfiguration(token)
      .then((response) => {
        if (response.status === 200) {
          const baseSize = response?.data?.base_size?.toString() || "";
          setBaseValue(baseSize);
          setInitialBaseValue(baseSize);
          setRecordId(response?.data?.recordId || null);
        }
      })
      .catch((error) => {
        handleError(error, navigate, dispatch);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to fetch configuration.",
          life: 3000,
        });
      });
  }, [token, dispatch, navigate]);

  return (
    <>
      <Toast ref={toast} />
      <div className="container-fluid page-wrapper">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card shadow-card" style={{ minHeight: "590px" }}>
              {renderHeaderAndControls()}
              <Divider
                style={{
                  margin: "0.5rem 0 !important",
                  padding: "0 1rem !important",
                }}
              />
              <label className="ms-3 mt-3 text-start">
                Minimum Base Size to Show Brands in Filters:
              </label>
              <InputText
                value={baseValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,3}$/.test(value)) {
                    setBaseValue(value);
                  }
                }}
                className="w-50 ms-3 inputField"
                maxLength={3} // Optional for safety
                placeholder="Enter number"
              />
              <div
                className="d-flex justify-content-center align-items-center text-center"
                style={{ marginTop: "30%" }}
              >
                <div className="d-flex gap-3">
                  <Button
                    label="CANCEL"
                    className="px-4 py-2 fw-bold cancel"
                    onClick={() => setBaseValue(initialBaseValue)}
                    disabled={
                      !baseValue || baseValue === initialBaseValue || isSaving
                    }
                  />
                  <Button
                    label="SAVE"
                    className="px-4 py-2 fw-bold createClientBtn"
                    onClick={handleSaveConfiguration}
                    disabled={
                      !baseValue || baseValue === initialBaseValue || isSaving
                    }
                    loading={isSaving}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Configuration;
